import { render, staticRenderFns } from "./PanelSolicitudes.vue?vue&type=template&id=0cd99b90&scoped=true&"
import script from "./PanelSolicitudes.vue?vue&type=script&lang=js&"
export * from "./PanelSolicitudes.vue?vue&type=script&lang=js&"
import style0 from "./PanelSolicitudes.vue?vue&type=style&index=0&id=0cd99b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd99b90",
  null
  
)

export default component.exports